import type { Language } from "../../contexts/LanguageContext";

export const appShellLabels: Record<Language, {
  subscriptionBanner: { text: string; button: string };
  logoutDialog: { title: string; description: string; confirm: string; cancel: string };
}> = {
  pt: {
    subscriptionBanner: {
      text: "Assine um plano e desbloqueie funcionalidades avançadas para sua agenda.",
      button: "Assinar",
    },
    logoutDialog: {
      title: "Sair",
      description: "Tem certeza que deseja sair?",
      confirm: "Sair",
      cancel: "Cancelar",
    },
  },
  en: {
    subscriptionBanner: {
      text: "Subscribe to unlock advanced scheduling features.",
      button: "Subscribe",
    },
    logoutDialog: {
      title: "Logout",
      description: "Are you sure you want to logout?",
      confirm: "Logout",
      cancel: "Cancel",
    },
  },
};

